var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivebullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2072_18627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.36C0.5 1.78047 1.78047 0.5 3.36 0.5H9.93137C11.9023 0.5 13.5 2.09773 13.5 4.06863V7.08667C13.5 10.6287 10.6287 13.5 7.08667 13.5C3.44895 13.5 0.5 10.551 0.5 6.91333V3.36Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.36C0.5 1.78047 1.78047 0.5 3.36 0.5H9.93137C11.9023 0.5 13.5 2.09773 13.5 4.06863V7.08667C13.5 10.6287 10.6287 13.5 7.08667 13.5C3.44895 13.5 0.5 10.551 0.5 6.91333V3.36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36 1.5H9.93137V-0.5H3.36V1.5ZM12.5 4.06863V7.08667H14.5V4.06863H12.5ZM1.5 6.91333V3.36H-0.5V6.91333H1.5ZM7.08667 12.5C4.00124 12.5 1.5 9.99876 1.5 6.91333H-0.5C-0.5 11.1033 2.89667 14.5 7.08667 14.5V12.5ZM12.5 7.08667C12.5 10.0764 10.0764 12.5 7.08667 12.5V14.5C11.1809 14.5 14.5 11.1809 14.5 7.08667H12.5ZM9.93137 1.5C11.35 1.5 12.5 2.65001 12.5 4.06863H14.5C14.5 1.54544 12.4546 -0.5 9.93137 -0.5V1.5ZM3.36 -0.5C1.22818 -0.5 -0.5 1.22818 -0.5 3.36H1.5C1.5 2.33275 2.33275 1.5 3.36 1.5V-0.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2072_18627)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivebullet);
export default __webpack_public_path__ + "static/media/activebullet.60f117b2c033d2ab944331eabb5f7cc1.svg";
export { ForwardRef as ReactComponent };